import { getStorageItem } from "./common-utils";

export const OWNER_ONLY_ALLOWED_EMAIL = "sushenkhalifa@gmail.com";
export const TRADE_DESK_ACCOUNTS = [
  { email: OWNER_ONLY_ALLOWED_EMAIL, name: "Sushen" },
  { email: "komalprabhakar2@gmail.com", name: "Komal" },
  { email: "somesh.ankush@gmail.com", name: "Somesh Ankush" },
];
export const TRADE_DESK_ALLOWED_EMAILS = TRADE_DESK_ACCOUNTS.map((account) => account.email);

const normalizeEmail = (email) => String(email || "").trim().toLowerCase();

export const getTradeDeskAccountName = (email) =>
  TRADE_DESK_ACCOUNTS.find((account) => account.email === normalizeEmail(email))?.name || normalizeEmail(email) || "Unknown account";

export const getSessionEmail = (session) => normalizeEmail(session?.user?.email);

export const getStoredSessionEmail = () => {
  const session = getStorageItem("userSession");
  return getSessionEmail(session);
};

export const canSeeMentorship = () => true;

export const canSeeOwnerOnlyFeatures = (session) => {
  const email = session === undefined ? getStoredSessionEmail() : getSessionEmail(session);
  return email === OWNER_ONLY_ALLOWED_EMAIL;
};

export const canSeePatternz = (session) => {
  const email = session === undefined ? getStoredSessionEmail() : getSessionEmail(session);
  return Boolean(email);
};

export const canSeeTradeDesk = (session) => {
  const email = session === undefined ? getStoredSessionEmail() : getSessionEmail(session);
  return TRADE_DESK_ALLOWED_EMAILS.includes(email);
};
